import React, { Component } from 'react'
import PT from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import cx from 'classnames'
import L6 from './6'
import L8 from './8'
import L9 from './9'
import './Logo.css'

class Logo extends Component {
  state = {
    isNumberHovered: false,
  }

  getLogoLinks(is89) {
    if (is89) {
      return (
        <div className="logo-container">
          <Link
            to="/"
            className="logo-inactive"
            onClick={this.handleLogoClick}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <L6 />
          </Link>
          <Link to="/89" className="logo-active" onClick={this.handleLogoClick}>
            <L8 className={cx({ hovered: this.state.isNumberHovered })} />
            <L9 />
          </Link>
        </div>
      )
    }
    return (
      <div className="logo-container">
        <Link to="/" className="logo-active" onClick={this.handleLogoClick}>
          <L6 />
          <L8 className={cx({ hovered: this.state.isNumberHovered })} />
        </Link>
        <Link
          to="/89"
          className="logo-inactive"
          onClick={this.handleMouseLeave}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <L9 />
        </Link>
      </div>
    )
  }

  handleLogoClick = () => {
    const { pathname } = this.props.location
    const isHome = pathname === '/' || pathname.startsWith('/89')

    this.handleMouseLeave()

    if (isHome) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  handleMouseEnter = () => {
    this.setState({ isNumberHovered: true })
  }

  handleMouseLeave = () => {
    this.setState({ isNumberHovered: false })
  }

  render() {
    const is89 = this.props.location.pathname.startsWith('/89')

    return (
      <div className={cx('logo-container', { is89 })}>
        <h1>
          <span>Spýtaj sa Vašich</span>
          {this.getLogoLinks(is89)}
        </h1>
      </div>
    )
  }
}

Logo.propTypes = {
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(Logo)



// WEBPACK FOOTER //
// ./src/components/Header/Logo/Logo.js